import { useState, useEffect, useContext, useCallback } from 'react'
import { TokenContext } from '../Main.js'

import { FiTrash2 } from 'react-icons/fi'

import { printSelect } from './../InputComponents.js'
import { sendRequest } from './../../rest/requests.js'

import Loader from './../Loader'

export const UserManager = () => {
    // access-token
    const [tokenObject, setTokenObject] = useContext(TokenContext);

    // -- state
    const [initialized, setInitialized] = useState(false);
    const [users, setUsers] = useState([]);
    const [isLoading, setIsLoading] = useState(true); // Eigener Lade-Status

    // -- init
    const initUserManager = useCallback(async () => {
        setIsLoading(true);
        const response = await sendRequest(tokenObject, setTokenObject, 'GET', '/nutzer', 'Lade alle Nutzer', 'Nutzer geladen');

        if (response.success) {
            setUsers(response.data);
        }
        // Setzt den initialen Ladevorgang auf abgeschlossen und den allgemeinen Lade-Indikator auf false
        setInitialized(true);
        setIsLoading(false);
    }, [tokenObject, setTokenObject]);

    useEffect(() => {
        initUserManager();
    }, [initUserManager]);

    // -- delete a user
    const deleteThisUser = useCallback(async (userToDelete) => {
        if (window.confirm(`Nutzer ${userToDelete.Nachname} wirklich löschen?`)) {
            const response = await sendRequest(tokenObject, setTokenObject, 'DELETE', `/nutzer/${userToDelete.Mail}`, `Lösche Nutzer ${userToDelete.Nachname}`, `Nutzer ${userToDelete.Nachname} gelöscht`);

            if (response.success) {
                // Lokalen State aktualisieren statt Neuladen
                setUsers(currentUsers => currentUsers.filter(u => u.Mail !== userToDelete.Mail));
            }
        }
    }, [tokenObject, setTokenObject]);

    // -- rolle on change
    const rolleOnChange = useCallback(async (e, userToUpdate) => {
        const newRole = e.currentTarget.value;
        const updatedUser = { ...userToUpdate, Rolle: newRole };

        const response = await sendRequest(tokenObject, setTokenObject, 'PATCH', '/nutzer', 'Speichere Nutzer-Rolle', 'Nutzer-Rolle gespeichert', updatedUser);

        if (response.success) {
            // Lokalen State aktualisieren statt Neuladen
            setUsers(currentUsers =>
                currentUsers.map(u =>
                    u.Mail === userToUpdate.Mail ? updatedUser : u
                )
            );
        }
    }, [tokenObject, setTokenObject]);

    if (!initialized) {
        return <Loader />;
    }

    return (
        <div className='basic-container'>
            <span className='headline-add-btn'>
                <h1>Academy2 Nutzer<sup>*</sup>innen</h1>
            </span>

            {/* Optional: Lade-Indikator für Aktionen nach der Initialisierung */}
            {isLoading && <p>Aktualisiere...</p>}

            <div className='table-container'>
                <table>
                    <tbody>
                        {users.map((user) =>
                            <tr key={user.Mail}>
                                <td>{user.Vorname} {user.Nachname}</td>
                                <td>{user.Mail}</td>
                                <td className='column-input'>{printSelect((e) => rolleOnChange(e, user), `user-role-input-${user.Mail}`, '', user.Rolle, ["Nutzer", "Projektleiter", "Admin"])}</td>
                                <td className='column-icon underline delete' onClick={() => deleteThisUser(user)}><FiTrash2 /></td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
            <div className='seperator'></div>
        </div>
    );
}

export default UserManager;